import {getProperties} from "@models/search";
import {storeAreaCommentLike, getNorthCitiesIds} from "@models/area";
import {getWidgets} from "@models/widget";
import {isEmpty, str_replace} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";

export const AreaStatItemsLabels = {
    transportation: {
        1: 'خیلی سخت',
        2: 'سخت',
        3: 'معمولی',
        4: 'راحت',
        5: 'خیلی راحت',
    },
    culture: {
        1: 'خیلی بد',
        2: 'بد',
        3: 'معمولی',
        4: 'خوب',
        5: 'عالی',
    },
    amenities: {
        1: 'خیلی کم',
        2: 'کم',
        3: 'معمولی',
        4: 'زیاد',
        5: 'عالی',
    },
    traffic: {
        1: 'خیلی سنگین',
        2: 'سنگین',
        3: 'معمولی',
        4: 'سبک',
        5: 'خیلی سبک',
    },
};

export const AreaStatItems = ['transportation', 'culture', 'amenities', 'traffic'];

export function handleAreaStatsCaption(stat) {
    const stats = {
        transportation: 'حمل‌و‌نقل عمومی',
        culture: 'بافت فرهنگی',
        amenities: 'امکانات رفاهی',
        traffic: 'میزان ترافیک',
    };

    return stats[stat];
}

export function handleAreaStatsTooltip(stat) {
    const stats = {
        transportation: '',
        culture: 'میزان آرامش محله، سطح فرهنگ اهالی محله، میزان جرم، جنایت و خشونت',
        amenities: 'فروشگاه، بازار و مجتمع تجاری، بیمارستان، سالن سینما، پارک، شهربازی و ...',
        traffic: '',
    };

    return stats[stat];
}

export function handleAreaStatsText(stat, percent) {
    let value = 3; // default value

    if (!isEmpty(percent)) {
        value = Math.round(percent / 20); // make value between 1-5

        if (value < 1) {
            value = 1
        }
    }

    return AreaStatItemsLabels[stat][value];
}


export async function getAreaProperties(city_id, district_id, deal_type) {
    const params = {
        city_id: city_id,
        district_id: [district_id],
        types: ['apartment'],
        deal_type: deal_type,
        sort: 'boosted_at',
        has_media: 1,
        exclude_archived: 1,
        count: 8
    };

    const search = await getProperties(1, null, params, false);

    return search.properties;
}

/**
 * @param comment {Object}
 * @param like {Boolean}
 * @param commentLikes {Object}
 * @param setCommentLikes {Function}
 * */
export function handleCommentLikeAndDisLike(comment, like, commentLikes, setCommentLikes) {
    const status = commentLikes.status;
    const likes = like ? comment['likes'] + 1 : comment['likes'];
    const dislikes = like ? comment['dislikes'] : comment['dislikes'] + 1;

    if (isEmpty(status) || (like && status === 'dislike') || (!like && status === 'like')) {

        setCommentLikes({
            likes: !isEmpty(likes) ? likes : 0,
            dislikes: !isEmpty(dislikes) ? dislikes : 0,
            status: (like ? 'like' : 'dislike')
        });

        storeAreaCommentLike(comment.area_id, comment.id, like).then(result => {

        }).catch(err => {
            setCommentLikes({
                likes: !isEmpty(comment.likes) ? comment.likes : 0,
                dislikes: !isEmpty(comment.dislikes) ? comment.dislikes : 0,
            });
        });
    }
}

export function areaShowPageRobots() {
    return 'index, follow, all';
}

export function getAreaShowMetas(area, meta) {
    let value = '';

    if (!isEmpty(area) && !isEmpty(area['meta']) && !isEmpty(area['meta'][meta])) {
        value = area['meta'][meta];
    }

    return value;
}

export async function getAreaFaqs(area_id) {
    const params = {
        item_id: area_id,
        type: 'content',
        page: 'area',
        section: 'faq',
        count: 10
    };

    const result = await getWidgets(params);

    return (!isEmpty(result) && result.widgets) ? result.widgets : [];
}

export async function makeAreaShowHotLinks(city_id, city_name, district_name) {
    const northCities = await getNorthCitiesIds();

    let links = [];

    if (inArray(city_id, northCities)) {
        links.push({
            url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-ویلا',
            caption: 'خرید ویلا در ' + city_name,
        });

        if (!isEmpty(district_name)) {
            links.push({
                url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-ویلا/' + str_replace(' ', '-', district_name),
                caption: 'خرید ویلا در ' + district_name,
            });
        }
    } else {
        links.push({
            url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-آپارتمان',
            caption: 'خرید خانه در ' + city_name,
        });

        if (!isEmpty(district_name)) {
            links.push({
                url: '/املاک-' + str_replace(' ', '-', city_name) + '/خرید-فروش-آپارتمان/' + str_replace(' ', '-', district_name),
                caption: 'خرید خانه در ' + district_name,
            });
        }
    }

    links.push({
        url: '/املاک-' + str_replace(' ', '-', city_name),
        caption: 'املاک ' + city_name,
    });

    return links;
}

export async function getAreaShowHotLinks(area) {
    const params = {
        item_id: area.id,
        type: 'static_links',
        page: 'area',
        section: 'hot_links',
        count: 10
    };

    let lists = [];

    const result = await getWidgets(params);

    if (!isEmpty(result) && result.widgets && result.widgets.length) {
        for (let widget of result.widgets) {
            lists.push({href: widget.url, hrefAs: widget.url, title: widget.caption})
        }
    } else {
        const links = await makeAreaShowHotLinks(area.city_id, area.city_name, area.district_name);

        if (links) {
            for (let widget of links) {
                lists.push({href: widget.url, hrefAs: widget.url, title: widget.caption})
            }
        }
    }

    return lists;
}